import { ApiService } from '../../constants';
import { HttpService } from '../../utilities';

export const getCategoryList = () => {
  return HttpService.post(
    `${ApiService.icdc.module.navbarCategory.getListCategoryNavbar}`,
    {}
  );
};

export const getMasterInterest = () => {
  return HttpService.get(
    `${ApiService.icdc.module.interest.listMasterInterest}`
  );
};

export const getDataInterestUser = (email) => {
  return HttpService.get(
    `${ApiService.icdc.module.interest.listInterestUser}?email=${email}`
  );
};

export const postInterest = (data) => {
  return HttpService.post(`${ApiService.icdc.module.interest.saveInterest}`, {
    ...data
  });
};
